
  const spans = document.querySelectorAll(".linear-text .text-block");
  let index = 0;

  function showNextText() {
    spans.forEach(span => span.classList.remove("active"));
    spans[index].classList.add("active");
    index = (index + 1) % spans.length; // loop
  }

  showNextText();
  setInterval(showNextText, 4000);



function initAnnouncementSlider() {
  if ($('.announcement-slider').length && !$('.announcement-slider').hasClass('slick-initialized')) {
    $('.announcement-slider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      autoplay: true,
      prevArrow:
        "<img class='custom-arrow slick-prev' src='https://cdn.shopify.com/s/files/1/0765/5391/2561/files/f9zazs4cqsmhmi4goh.svg?v=1762377810'>",
      nextArrow:
        "<img class='custom-arrow slick-next' src='https://cdn.shopify.com/s/files/1/0765/5391/2561/files/dtxufnppom7mhmi4ra1.svg?v=1762377779'>",
      fade: true,
      cssEase: 'linear'
    });
  }
}

$(document).ready(initAnnouncementSlider);
$(document).on('shopify:section:load', initAnnouncementSlider);
